document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.querySelector('[data-mobile-panel]');
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
});
